import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment TermFragment
 * @since 1.0.0
 */
export const TermFragment = gql `
  fragment TermFragment on Term {
    id
    type
    primary
    title
    infos

    file {
      id
      url
    }

    partner {
      id
      name
    }

    translations {
      id
      title
      infos

      language {
        ...LanguageFragment
      }
    }
  }

  ${LanguageFragment}
`;
